const constants = {
    ADD_ADDRESS:'Add Address',
    ERROR_MSG: 'Fill all the fields'
}
export default constants;